export default __webpack_public_path__ + "static/media/img4.118c380a.png";